<template>
  <div>
    <div class="card-header">
      <div class="d-flex justify-content-end gap-2 align-items-center">
        <button
          @click="openModal('add', null, 'activity')"
          class="btn btn-primary d-flex align-items-center gap-1 ms-auto md-mt-0 mt-0"
          v-if="$can('backoffice.customer-activity.create')"
        >
          <feather-icon :icon="'AddIcon'" size="12" />
          <span>{{ $t("createCompanyActivity") }}</span>
        </button>
        <button
          @click="openModal('add', null, 'notes')"
          class="btn btn-primary d-flex align-items-center gap-1 ms-auto md-mt-0 mt-0"
          v-if="$can('backoffice.customer-note.create')"
        >
          <feather-icon :icon="'AddIcon'" size="12" />
          <span>{{ $t("createCustomNotes") }}</span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-7">
          <div class="dextop-table-view">
            <div class="table-responsive api-keys-table">
              <vue-good-table
                styleClass="vgt-table striped"
                :columns="columns"
                :fixed-header="false"
                :rows="rows"
                :pagination-options="{
                  enabled: false,
                  perPage: pageLength,
                }"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
              >
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Name -->

                  <span
                    class="d-flex align-items-center justify-content-center gap-2"
                    v-if="props.column.field === 'action'"
                  >
                    <div
                      class="cursor-pointer"
                      @click="openModal('edit', props.row, 'activity')"
                      v-if="$can('backoffice.customer-activity.edit')"
                    >
                      <feather-icon size="16" icon="Edit2Icon" />
                    </div>
                    <div
                      class="cursor-pointer"
                      @click="destroy(props.row.id, 'activity')"
                      v-if="$can('backoffice.customer-activity.delete')"
                    >
                      <feather-icon size="16" icon="TrashIcon" />
                    </div>
                  </span>
                  <span v-if="props.column.field === 'createdAt'">
                    <p class="">
                      {{ $dateFormatter(props.row.createdAt, $i18n.locale) }}
                    </p>
                  </span>
                  <span
                    v-else-if="
                      props.column.field === 'userId' &&
                      userProfiles[props.row.userId]
                    "
                  >
                    {{
                      (userProfiles[props.row.userId].first_name || "") +
                      " " +
                      (userProfiles[props.row.userId].last_name || "")
                    }}
                  </span>
                  <!-- Column: Common -->
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <b-form-group class="mb-0">
                <div class="d-flex align-items-center">
                  <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['25', '50', '100']"
                    class="ml-1"
                    @input="(value) => onPerPageChange({ pageLength: value })"
                  />
                </div>
              </b-form-group>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalRecords"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                  @input="(value) => onPageChange({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
          <div class="reponsive-view-cards mb-2">
            <div class="row">
              <div class="col-md-6" v-for="row in rows" :key="row.id">
                <div class="card mb-1">
                  <div
                    class="card-header d-flex align-items-center justify-content-between"
                  >
                    <h5 class="card-title">
                      {{ $dateFormatter(row.createdAt, $i18n.locale) }}
                    </h5>
                    <div class="d-flex gap-2">
                      <div
                        class="cursor-pointer"
                        @click="openModal('edit', row, 'activity')"
                        v-if="$can('backoffice.customer-activity.edit')"
                      >
                        <feather-icon size="18" icon="Edit2Icon" />
                      </div>
                      <div
                        class="cursor-pointer"
                        @click="destroy(row.id, 'activity')"
                        v-if="$can('backoffice.customer-activity.delete')"
                      >
                        <feather-icon size="18" icon="TrashIcon" />
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0">
                    <ul class="card-list">
                      <li>
                        <div class="left">
                          <strong>{{ $t("type") }}: </strong>
                        </div>
                        <div class="right">
                          <span>{{ row.type }}</span>
                        </div>
                      </li>
                      <li>
                        <div class="left">
                          <strong>{{ $t("nextStep") }}: </strong>
                        </div>
                        <div class="right">
                          <span>{{ row.nextStep }}</span>
                        </div>
                      </li>
                      <li>
                        <div class="left">
                          <strong>{{ $t("user") }}: </strong>
                        </div>
                        <div class="right">
                          <span>
                            {{
                              userProfiles[row.userId]
                                ? (userProfiles[row.userId].first_name || "") +
                                  " " +
                                  (userProfiles[row.userId].last_name || "")
                                : ""
                            }}
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="left">
                          <strong>{{ $t("Description") }}: </strong>
                        </div>
                        <div class="right">
                          <span>{{ row.description }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <b-pagination
                :value="1"
                :total-rows="totalRecords"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => onPageChange({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="dextop-table-view">
            <div class="table-responsive">
              <vue-good-table
                styleClass="vgt-table striped"
                :columns="columnsNote"
                :fixed-header="false"
                :rows="rowsNotes"
                :pagination-options="{
                  enabled: false,
                  perPage: pageLengthNotes,
                }"
                mode="remote"
                @on-page-change="onPageChangeNotes"
                @on-sort-change="onSortChangeNotes"
                @on-per-page-change="onPerPageChangeNotes"
              >
                <template slot="table-row" slot-scope="props">
                  <span
                    class="d-flex align-items-center justify-content-center gap-2"
                    v-if="props.column.field === 'action'"
                  >
                    <div
                      class="cursor-pointer"
                      @click="openModal('edit', props.row, 'notes')"
                      v-if="$can('backoffice.customer-note.edit')"
                    >
                      <feather-icon size="16" icon="Edit2Icon" />
                    </div>
                    <div
                      class="cursor-pointer"
                      @click="destroy(props.row.id, 'notes')"
                      v-if="$can('backoffice.customer-note.delete')"
                    >
                      <feather-icon size="16" icon="TrashIcon" />
                    </div>
                  </span>
                  <span
                    v-else-if="
                      props.column.field === 'userId' &&
                      userProfiles[props.row.userId]
                    "
                  >
                    {{
                      (userProfiles[props.row.userId].first_name || "") +
                      " " +
                      (userProfiles[props.row.userId].last_name || "")
                    }}
                  </span>
                  <!-- Column: Common -->
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <b-form-group class="mb-0">
                <div class="d-flex align-items-center">
                  <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
                  <b-form-select
                    v-model="pageLengthNotes"
                    :options="['25', '50', '100']"
                    class="ml-1"
                    @input="
                      (value) => onPerPageChangeNotes({ pageLength: value })
                    "
                  />
                </div>
              </b-form-group>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalRecordsNotes"
                  :per-page="pageLengthNotes"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                  @input="(value) => onPageChange({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
          <div class="reponsive-view-cards">
            <div class="row">
              <div class="col-md-6" v-for="row in rowsNotes" :key="row.id">
                <div class="card mb-1">
                  <div
                    class="card-header d-flex align-items-center justify-content-between"
                  >
                    <h5 class="card-title">
                      {{ $t("customNotes") }}
                    </h5>
                    <div class="d-flex gap-2">
                      <div
                        class="cursor-pointer"
                        @click="openModal('edit', row, 'notes')"
                        v-if="$can('backoffice.customer-note.edit')"
                      >
                        <feather-icon size="18" icon="Edit2Icon" />
                      </div>
                      <div
                        class="cursor-pointer"
                        @click="destroy(row.id, 'notes')"
                        v-if="$can('backoffice.customer-note.delete')"
                      >
                        <feather-icon size="18" icon="TrashIcon" />
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0">
                    <ul class="card-list">
                      <li>
                        <div class="left">
                          <strong>{{ $t("customNotes") }}: </strong>
                        </div>
                        <div class="right">
                          <span>{{ row.customNotes }}</span>
                        </div>
                      </li>
                      <li>
                        <div class="left">
                          <strong>{{ $t("user") }}: </strong>
                        </div>
                        <div class="right">
                          <span>
                            {{
                              userProfiles[row.userId]
                                ? (userProfiles[row.userId].first_name || "") +
                                  " " +
                                  (userProfiles[row.userId].last_name || "")
                                : ""
                            }}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <b-pagination
                :value="1"
                :total-rows="totalRecordsNotes"
                :per-page="pageLengthNotes"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => onPageChangeNotes({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="edit-tag-modal"
      v-model="showModal"
      :title="modalTitle"
      centered
      size="lg"
      hide-footer
    >
      <div v-if="(companyName || notificationMail) && modalType === 'add' && activityType === 'notes'">
        <b-row class="mb-2 mt-2">
          <b-col v-if="companyName" cols="12" md="6">
            <p><strong>{{ $t('companyName') }}:</strong> {{ companyName }}</p>
          </b-col>
          <b-col v-if="notificationMail" cols="12" md="6">
            <p><strong>{{ $t('notificationMail') }}:</strong> {{ notificationMail }}</p>
          </b-col>
        </b-row>
      </div>
      <validation-observer ref="activityRules">
        <b-row>
          <b-col v-if="activityType == 'activity'" cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Type"
              rules="required"
            >
              <label class="input-label form-label"
                >{{ $t("type") }}&nbsp;<span style="color: red">*</span>
              </label>
              <multiselect
                v-model="activity.type"
                :options="['meeting', 'call', 'message', 'event']"
                :multiple="false"
              >
              </multiselect>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <b-col v-if="activityType == 'activity'" cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Next Step"
              rules="required"
            >
              <TextInput
                v-model="activity.nextStep"
                :label="$t('nextStep')"
                :tooltipMessage="$t('nextStep')"
                :required="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label class="input-label form-label" for="cars"
              >{{
                activityType == "activity" ? $t("Description") : $t("Notes")
              }}&nbsp;<span style="color: red">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Text Area"
              rules="required"
            >
              <textarea
                class="form-control"
                rows="5"
                v-model="activity.description"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
        <div class="d-flex align-items-center justify-content-end mt-2">
          <b-button class="mr-1" @click="showModal = false" variant="primary"
            ><feather-icon :icon="'XIcon'" size="10" />{{
              $t("cancel")
            }}</b-button
          >
          <b-button
            v-if="
              modalType === 'add'
            "
            @click="saveRecord()"
            variant="primary"
            :disabled="isFormInvalid"
            ><feather-icon :icon="'PlusIcon'" size="10" />{{
              $t("create")
            }}</b-button
          >
          <b-button
            v-else
            @click="editRecord()"
            variant="primary"
            :disabled="isFormInvalid"
            ><feather-icon :icon="'PlusIcon'" size="10" />{{
              $t("update")
            }}</b-button
          >
        </div>
      </validation-observer>
    </b-modal>
    <!--==================================-->
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { debounce } from "@/utils/debounce";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import usersStoreMixin from "@/mixins/usersStoreMixin";
import { required, email } from "@validations";

export default {
  mixins: [usersStoreMixin],
  components: {
    TextInput,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
  },
  props: {
    companyName: {
      type: String,
      default: "",
    },
    notificationMail: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("users", ["userProfiles"]),
    columns() {
      const cols = [
        {
          label: this.$t("date"),
          field: "createdAt",
        },
        {
          label: this.$t("type"),
          field: "type",
        },
        {
          label: this.$t("nextStep"),
          field: "nextStep",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("user"),
          field: "userId",
        },
        {
          label: this.$t("Description"),
          field: "description",
        },
        {
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];

      return cols;
    },
    columnsNote() {
      const cols = [
        {
          label: this.$t("customNotes"),
          field: "customNotes",
        },
        {
          label: this.$t("user"),
          field: "userId",
        },
        {
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];

      return cols;
    },
    isFormInvalid() {
      return !this.activity.description;
    },
    modalTitle() {
      if (this.activityType === "notes") {
        return this.modalType === "add"
          ? this.$t("createCustomNotes")
          : this.$t("editCustomNotes");
      }

      return this.modalType === "add"
        ? this.$t("createActivity")
        : this.$t("editActivity");
    },
  },
  created() {
    this.debouncedFetch = debounce(async (newValue, oldValue) => {
      try {
        await this.loadItems();
      } catch (e) {
        console.error(e);
      }
    }, 300);
  },
  data() {
    return {
      activity: {
        type: "",
        description: "",
        nextStep: "",
      },
      totalRecords: 0,
      pageLength: 25,
      page: 1,
      totalRecordsNotes: 0,
      pageLengthNotes: 25,
      pageNotes: 1,
      activityType: "",
      rows: [],
      rowsNotes: [],
      showModal: false,
      sortBy: "createdAt",
      sortOrder: "desc",
      sortByNotes: "createdAt",
      sortOrderNotes: "desc",
      modalType: "add",
    };
  },
  async mounted() {
    this.loadItems();
    this.loadNotes();
  },
  methods: {
    async saveRecord() {
      const dispatchAction = async () => {
        const payload = {
          ...this.activity,
          companyId: this.$route?.params?.id,
          customNotes: this.activity.description,
        };

        if (this.activityType === "activity") {
          return this.$store.dispatch("customerActivities/create", payload);
        } else {
          return this.$store.dispatch("customerNotes/create", payload);
        }
      };

      const afterSuccess = () => {
        this.showModal = false;
        this.activity = {
          type: "",
          description: "",
          nextStep: "",
        };
      };

      if (this.activityType === "activity") {
        // validate only for activity
        this.$refs.activityRules.validate().then(async (success) => {
          if (success) {
            this.$store.commit("showLoader", true);
            await dispatchAction()
              .then(afterSuccess)
              .finally(() => {
                this.$store.commit("showLoader", false);
                this.loadItems();
              });
          }
        });
      } else {
        // skip validation
        this.$store.commit("showLoader", true);
        await dispatchAction()
          .then(afterSuccess)
          .finally(() => {
            this.$store.commit("showLoader", false);
            this.loadNotes();
          });
      }
    },
    async editRecord() {
      const dispatchAction = async () => {
        const payload = {
          id: this.selectedId,
          data: {
            ...this.activity,
            companyId: this.$route?.params?.id,
            customNotes: this.activity.description,
          },
        };

        if (this.activityType === "activity") {
          return this.$store.dispatch("customerActivities/update", payload);
        } else {
          return this.$store.dispatch("customerNotes/update", payload);
        }
      };

      const afterSuccess = () => {
        this.showModal = false;
        this.activity = {
          type: "",
          description: "",
          nextStep: "",
        };
      };

      if (this.activityType === "activity") {
        // validate only for activity
        this.$refs.activityRules.validate().then(async (success) => {
          if (success) {
            this.$store.commit("showLoader", true);
            await dispatchAction()
              .then(afterSuccess)
              .finally(() => {
                this.$store.commit("showLoader", false);
                this.loadItems();
              });
          }
        });
      } else {
        // skip validation
        this.$store.commit("showLoader", true);
        await dispatchAction()
          .then(afterSuccess)
          .finally(() => {
            this.$store.commit("showLoader", false);
            this.loadNotes();
          });
      }
    },
    onSortChangeNotes(params) {
      this.sortOrderNotes = params[0].type;
      if (params[0].type == "none") this.sortOrderNotes = "asc";

      this.sortByNotes = params[0].field;
      this.loadNotes();
    },
    onPerPageChangeNotes(params) {
      this.updateParamsNotes({ pageLengthNotes: params.pageLength });
      this.loadNotes();
    },
    onPageChangeNotes(params) {
      this.pageNotes = params.currentPage;
      this.loadNotes();
    },
    updateParamsNotes(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },
    onSortChange(params) {
      this.sortOrder = params[0].type;
      if (params[0].type == "none") this.sortOrder = "asc";

      this.sortBy = params[0].field;
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },
    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },
    openModal(type, item = null, activityType) {
      this.activity = {
        type: "",
        description: "",
        nextStep: "",
      };
      this.activityType = activityType;
      this.modalType = type;
      if (type === "edit" && item) {
        this.selectedId = item.id;
        if (activityType == "notes")
          this.activity.description = item.customNotes;
        else
          this.activity = {
            type: item.type,
            description: item.description,
            nextStep: item.nextStep,
          };
      }

      this.showModal = true;
    },

    async loadItems() {
      try {
        const companyId = this.$route?.params?.id;
        this.$store.commit("showLoader", true);

        let response = await this.$store.dispatch("customerActivities/list", {
          page: this.page,
          perPage: this.pageLength,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          companyId: companyId,
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.total;
        await this.getUserProfiles(this.rows.map((row) => row.userId));
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async loadNotes() {
      try {
        const companyId = this.$route?.params?.id;
        this.$store.commit("showLoader", true);

        let response = await this.$store.dispatch("customerNotes/list", {
          page: this.pageNotes,
          perPage: this.pageLengthNotes,
          sortBy: this.sortByNotes,
          sortOrder: this.sortOrderNotes,
          companyId: companyId,
        });
        this.rowsNotes = response?.data?.data;
        this.totalRecordsNotes = response?.data?.total;
        await this.getUserProfiles(this.rowsNotes.map((row) => row.userId));
        
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async destroy(id, type) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        this.$store.commit("showLoader", true);

        const action =
          type === "notes"
            ? "customerNotes/destroy"
            : "customerActivities/destroy";

        await this.$store.dispatch(action, id).finally(() => {
          this.$store.commit("showLoader", false);

          if (type === "notes") {
            this.loadNotes();
          } else {
            this.loadItems();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
